import React from 'react'
import { FaGithub, FaLinkedinIn, FaEnvelope } from 'react-icons/fa'

const data = [
  {
    id: 401,
    icon: <FaEnvelope className='social-icon'></FaEnvelope>,
    url: 'mailto:hello@virgiliocordero.com',
    aria: 'email mailto link',
    name: 'Email',
    rel: 'me',
  },
  {
    id: 402,
    icon: <FaGithub className='social-icon'></FaGithub>,
    url: 'https://github.com/vcordero07/',
    aria: 'github profile link',
    name: 'GitHub',
    rel: 'me',
  },
  {
    id: 403,
    icon: <FaLinkedinIn className='social-icon'></FaLinkedinIn>,
    url: 'https://www.linkedin.com/in/virgilio-cordero',
    aria: 'linkedin profile link',
    name: 'LinkedIn',
    rel: 'me',
  },
]

export default data
